import { IPurchasable } from "@smartrr/shared/entities/Purchasable";
import { PurchaseStateAndDelivery } from "@smartrr/shared/entities/PurchaseState";

import { usePurchasablesForSubscribing } from "@customer-app/account/views/OperationAquarius/AquariusInner/hooks/usePurchasablesForSubscribing";
import { useProductsListForSellingPlanId } from "@customer-app/state/reducers/sellingPlanGroups";

export const useUpdatedPurchasablesForAdding = (
  stalePurchasable: IPurchasable[],
  delivery: PurchaseStateAndDelivery,
  generatePurchasables: boolean
) => {
  const purchaseState = delivery.purchaseState;
  const allPurchasablesForDelivery = useProductsListForSellingPlanId(purchaseState.sellingPlanId, false);

  const purchasableForSubscribing = usePurchasablesForSubscribing(delivery);

  if (generatePurchasables) {
    return purchasableForSubscribing(delivery, allPurchasablesForDelivery);
  }

  return stalePurchasable;
};
